import React from 'react';
import Loader from '@/components/Generic/Loader';
import { MobileTableRow } from './MobileTableRow';
import classnames from 'classnames';
import { KidsTableProps } from '../shared/types';

export const MobileTable: React.FC<KidsTableProps> = ({
  rows,
  isLoading,
  className,
  selectedShareClasses,
  ...rest
}) => {
  if (isLoading && !rows.length) {
    return <Loader size={100} className="mx-auto my-5" />;
  }

  return (
    <div className={classnames('d-flex flex-column mt-2', className)}>
      {rows.length > 0 &&
        rows.map((row) => (
          <MobileTableRow
            key={row.id}
            row={row}
            selectedShareClass={selectedShareClasses[row.id] ?? 0}
            {...rest}
          />
        ))}
    </div>
  );
};
